const regexForOldRegistrationNo = /^[a-zA-Z]{2}[0-9]{1,3}[a-zA-Z]{1,3}[0-9]{4}$/;
const regexForBharatSeries = /^[0-9]{2}BH[0-9]{4}[A-HJ-NP-Z]{1,2}$/;
const regNoRegex = /^[A-Z]{2}[ -]{0,1}[0-9]{2}[ -]{0,1}[0-9]{1,4}$/;

export const isValidRegistrationNo = (v) => [
    regexForOldRegistrationNo,
    regexForBharatSeries,
    regNoRegex
].some(r => r.test(v));
